/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The common active class.
 */
export const DXP_ACTIVE_CLASS = `active`;
